<template>
  <div class="d-flex align-items-center">
    <user-short :user-id="userId" length="50"></user-short>
    <div class="ml-3">
      <div class="text-extra-large bold" :class="{ 'text-gradient': isLoggedInUser }" v-no-capture>
        {{ title }}
      </div>
      <div class="text-medium email" v-no-capture>{{ user.email }}</div>
    </div>
  </div>
</template>

<script>
import UserShort from '@/components/UserShort.vue'

/**
 * This component gives a block with below details of the user
 *  - avatar
 *  - name
 *  - email
 */
export default {
  name: 'UserBlock',
  props: ['userId'],
  components: {
    UserShort
  },
  data() {
    return {
      weekday: new Date().toLocaleString('en-US', { weekday: 'long' })
    }
  },
  computed: {
    isLoggedInUser() {
      const loggedInUser = this.$store.getters.user
      return this.userId === loggedInUser.id
    },
    user() {
      return this.$store.getters.userById(this.userId) || {}
    },
    title() {
      if (this.isLoggedInUser) {
        return 'Happy ' + this.weekday + ', ' + this.user.firstName
      } else {
        return this.user.displayName || ''
      }
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.email {
  font-weight: normal;
  margin-top: 2px;
}
</style>
